import { Spinner } from '@Common/Spinner';
import { CreditCardIcon } from '@heroicons/react/24/outline';
import { useAppDispatch } from 'hooks/store';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RESET_NOTIFICATION } from 'store/account/actionsTypes';
import { useGetPaymentsList } from 'store/subscription/actions';

import { AddPaymentMethod } from '../ChangeModals';
import { PaymentRow } from '../UI';

export const PaymentMethodsTab = () => {
  const [addPaymentModalOpen, setAddPaymentModalOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { data: paymentMethodsList, isPending } = useGetPaymentsList();

  useEffect(() => {
    dispatch({
      type: RESET_NOTIFICATION,
    });
  }, []);

  return (
    <>
      <AddPaymentMethod open={addPaymentModalOpen} setOpen={setAddPaymentModalOpen} />
      <div className="flex items-start flex-col">
        <div className="text-lg font-semibold">
          <FormattedMessage id="paymentMethods" />
        </div>

        {isPending ? (
          <Spinner color="bg-primary" />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full mt-3">
            {paymentMethodsList?.map((method) => {
              return <PaymentRow method={method} key={'payment-method-' + method.id} />;
            })}
            <button
              onClick={() => setAddPaymentModalOpen(true)}
              className="p-5 rounded-lg border min-h-[56px] md:min-h-[156px] flex flex-col items-center justify-center md:hover:bg-gray-100"
            >
              <div>
                <CreditCardIcon className="w-8 h-8" />
              </div>
              <div className="mt-1">
                <FormattedMessage id="addPayment" />
              </div>
            </button>
          </div>
        )}
      </div>
    </>
  );
};
